var path = 'app/scripts/modules/core/src/presentation/sortToggle/sorttoggle.directive.html';
var html = "<span ng-class=\"{'inactive-sort-key' : !ctrl.isSortKey(key)}\"\n      class=\"sort-toggle clickable\"\n      ng-click=\"ctrl.setSortKey(key, $event)\">\n  {{ label }} <a>\n    <span ng-if=\"!ctrl.isReverse() || !ctrl.isSortKey(key)\"\n          class=\"glyphicon glyphicon-Down-triangle\"></span>\n    <span ng-if=\"ctrl.isReverse() && ctrl.isSortKey(key)\"\n          class=\"glyphicon glyphicon-Up-triangle\"></span>\n  </a>\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/presentation/sortToggle/sorttoggle.directive.html
// module id = 1107
// module chunks = 0